import { render, staticRenderFns } from "./EntregaPCA.vue?vue&type=template&id=f866e934&scoped=true"
import script from "./EntregaPCA.vue?vue&type=script&lang=js"
export * from "./EntregaPCA.vue?vue&type=script&lang=js"
import style0 from "./EntregaPCA.vue?vue&type=style&index=0&id=f866e934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f866e934",
  null
  
)

export default component.exports